<template lang="pug">
div
  div(v-if="has_permission")
    modal-field-used-drawings(:form='newRecord', :is-add='isModalAdd')
    vm-row.heading(vm-w="12")
      vm-row(vm-w="12")
        vm-col(vm-type="flex" vm-justify="flex-end" vm-lg=12 vm-sm=12)
          div
            vm-button.separador-btn(icon="plus" @click="addFieldUsedDrawing" v-if="field_used_drawings_store_permission && inOrder.status != 5") {{ $t('strings.add') }}
        vm-col.card(vm-sm=12)
          vm-table(:data="fieldUsedDrawings")
            template(slot="header")
              .d-flex.justify-content-between
                div
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('field_used_drawings.' + column) }}
              vm-th
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column != 'status' && column != 'amount' && column != 'created_by' && column != 'category'") {{data[indextr][column]}}
                  slot(v-if="column == 'created_by'") {{ data[indextr]['user']['name'] }}
                  slot(v-if="column == 'amount'") {{ data[indextr]['amount'] | currency }}
                  slot(v-if="column == 'category'") {{ data[indextr]['category_display'] }}
                  vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status_display']}}
                  vm-status-indicator(v-if="column == 'type'" :pulse="data[indextr]['type'] !== 'Activo'" :color="colorType(data[indextr]['type'])") {{data[indextr]['type_display']}}
                vm-td
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(@click="editFieldUsedDrawing(data[indextr])")
                        vm-icon(icon="edit-outline")
                        slot &nbsp;{{ $t('strings.update') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="deleteFieldUsedDrawingConfirm(data[indextr])")
                        vm-icon(icon="trash-2-outline")
                        slot &nbsp;{{ $t('strings.delete') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="openViewer(data[indextr], indextr)" v-if="data[indextr] && data[indextr].filename && field_used_drawings_update_permission")
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('revisions.see_attachment') }}
  #no-access(v-else)
    access-denied
</template>
<script>
import ModalFieldUsedDrawings from '@/components/in-order/ModalFieldUsedDrawings.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'FieldUsedDrawings',
  components: {
    ModalFieldUsedDrawings
  },
  data: () => ({
    selected: [],
    newRecord: {},
    has_permission: true,
    field_used_drawings_store_permission: true,
    isModalAdd: true,
    columns: [
      'title',
      'category',
      'drawing_number',
      'revision',
      'date',
      'created_by'
    ],
    status: [
      {
        text: 'Open',
        value: 1,
        color: '#ff8200'
      },
      {
        text: 'Approve',
        value: 2,
        color: 'success'
      },
      {
        text: 'Cancel',
        value: 3,
        color: 'danger'
      }
    ],
    type: [
      {
        text: 'Additive',
        value: 1,
        color: 'success'
      },
      {
        text: 'Deductive',
        value: 2,
        color: 'danger'
      }
    ]
  }),
  async created () {
    this.checkPermissionView('field_used_drawings.index')
    this.$route.params.id && await this.getFieldUsedDrawings()
  },
  methods: {
    ...mapActions([
      'loadFieldUsedDrawings',
      'setModalFieldUsedDrawingsVisible',
      'actionFieldUsedDrawing',
      'deleteFieldUsedDrawing'
    ]),
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.field_used_drawings_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'field_used_drawings.store') > -1
      this.field_used_drawings_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'field_used_drawings.update') > -1
    },
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    colorType (code) {
      return this.type.find(e => e.value === parseInt(code))['color']
    },
    async getFieldUsedDrawings () {
      this.loadFieldUsedDrawings(this.$route.params)
    },
    addFieldUsedDrawing () {
      this.isModalAdd = true
      this.setModalFieldUsedDrawingsVisible(true)
    },
    editFieldUsedDrawing (drawing, index) {
      this.isModalAdd = false
      this.setModalFieldUsedDrawingsVisible(true)
      this.newRecord = { ...drawing }
    },
    async setActionFieldUsedDrawing (record, action) {
      record.id && this.actionFieldUsedDrawing({ id: record.id, action })
    },
    async deleteFieldUsedDrawingConfirm (record) {
      let t = this
      this.auxDeleteFieldUsedDrawing = () => {
        t.deleteFieldUsedDrawing(record).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.field_used_drawing'), attribute: this.$t(record.id) }),
        accept: this.auxDeleteFieldUsedDrawing
      })
    },
    openViewer (drawing) {
      this.$viewer.show({
        urlFile: drawing.file_url,
        mime: 'application/pdf',
        name: drawing.filename,
        color: '#FFF'
      })
    }
  },
  computed: {
    ...mapGetters([
      'inOrder',
      'fieldUsedDrawings'
    ])
  }
}
</script>
<style lang="scss">
  .filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
  }
  .con-vm-tooltip {
  display: inline-block;
  position: relative;
  }
  .vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
